module.exports = __webpack_public_path__ + "static/img/desktop-sbgl.274f7588.png";